import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Icon from '~/components/Icon';
import { AddLogoModalContent, FoldedMenu, Link } from '~/components';
import images from '~/constants/images';
import { signOutRequest } from '~/store/modules/auth/actions';
import { languageOptions } from '~/utils/languageOptions';
import EditUser from '~/pages/EditUser';
import EditPassword from '~/pages/EditPassword';
import * as S from '../styles';
import { propTypes, defaultProps } from './propsValidation';

export default function Header({ user }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showModal, setModalVisibility] = useState(false);

  useEffect(() => {
    if (user.firstLogin) {
      setModalVisibility('editLogo');
    }
  }, [user, setModalVisibility]);

  return (
    <S.Header>
      <S.HeaderBackground />
      <Link to="/">
        <S.LaLigaLogo src={images.logoWhiteHorizontal} />
      </Link>
      {user.logo && <S.BrandLogo src={`${user.logo}`} />}
      <S.AppName>{t('appName').toUpperCase()}</S.AppName>
      <FoldedMenu label={t('languageId')} options={languageOptions()} />
      <FoldedMenu
        label={
          <>
            {user && user.firstName && user.lastName && user.mediaName
              ? `${user.firstName} ${user.lastName} (${user.mediaName})`
              : `${t('loading')}...`}
            <Icon name="avatar" size={15} color="coral" />
          </>
        }
        options={[
          {
            label: t('editAccount'),
            action: () => setModalVisibility('editUser'),
            isLaligaOption: false,
          },
          {
            label: t('changeLogo'),
            action: () => setModalVisibility('editLogo'),
            isLaligaOption: false,
          },
          {
            label: t('editPassword'),
            action: () => setModalVisibility('editPassword'),
            isLaligaOption: false,
          },
          {
            label: t('logout'),
            action: async () => {
              dispatch(signOutRequest());
            },
            isLaligaOption: true,
          },
        ].filter(item => (user.laliga ? item.isLaligaOption : true))}
      />
      <S.PopUpViewHeader
        zone="whole"
        isOpen={showModal}
        onClose={() => {
          setModalVisibility(false);
        }}
        maxWidth={showModal === 'editPassword' ? '406px' : false}
      >
        {showModal === 'editLogo' && (
          <AddLogoModalContent
            closeModal={() => {
              setModalVisibility(false);
            }}
          />
        )}
        {showModal === 'editPassword' && (
          <EditPassword
            onClose={() => setModalVisibility(false)}
            onSubmit={() => setModalVisibility(false)}
          />
        )}
        {showModal === 'editUser' && (
          <EditUser
            onSubmit={() => setModalVisibility(false)}
            onClose={() => setModalVisibility(false)}
          />
        )}
      </S.PopUpViewHeader>
    </S.Header>
  );
}

Header.propTypes = propTypes;

Header.defaultProps = defaultProps;
